import { Box, Container, Typography } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";

function Uber() {
  const ref = useRef(null);
  const { animationStarted } = useAnimation();
  const isInView = useInView(ref, { once: true, margin: "0px" });

  return (
    <Container
      component={motion.div}
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={
        isInView && animationStarted
          ? { opacity: 1, y: 0 }
          : { opacity: 0, y: 30 }
      }
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      sx={{ mt: { xs: 4, md: 4, lg: 6 } }}
    >
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Open Sans", sans-serif',
          fontSize: { xs: "1.35rem", sm: "1.5rem" },
          fontWeight: 400,
          color: "#1a3a52",
          mb: 3,
          mt: { xs: 8, md: 0 },
          textAlign: "center",
        }}
      >
        Uber
      </Typography>
      <Typography
        variant="body1"
        align="justify"
        sx={{
          fontFamily: '"Open Sans", sans-serif',
          fontSize: { xs: "1rem", sm: "1.1rem" },
          lineHeight: 2,
          color: "#2d4e66",
        }}
      >
        Embora a Uber seja muito utilizada em Portugal, a disponibilidade de
        motoristas na zona de Alenquer pode ser limitada. Se preferirem utilizar
        a Uber como meio de transporte, recomendamos que tentem agendar a viagem
        com antecedência.
      </Typography>
    </Container>
  );
}

export default Uber;
